const modalForm = document.querySelector(".js-popup-form");
const modalclose = document.querySelector(".js-closeForm");
console.log(modalForm);

if (modalForm) {
	modalclose.addEventListener("click", () => {
		modalForm.classList.add("hidden");
		console.log("hello");
	});
	console.log("hello");
}

console.log("hello");
